import React from 'react'

export default function PasswordStrengthBar({ password }) {
  let score = 0
  if (password.length >= 8) score++
  if (password.length >= 12) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++

  if (!password) return null

  let label, color, width
  if (score <= 2) { label = 'Débil'; color = '#dc3545'; width = '33%' }
  else if (score <= 4) { label = 'Media'; color = '#ffc107'; width = '66%' }
  else { label = 'Fuerte'; color = '#00C853'; width = '100%' }

  return (
    <div className="mt-2">
      <div className="rounded-pill" style={{ height: 4, background: '#eee', overflow: 'hidden' }}>
        <div style={{ height: '100%', width, background: color, borderRadius: 'inherit', transition: 'all 0.3s ease' }} />
      </div>
      <small style={{ color, fontSize: 11 }}>{label}</small>
    </div>
  )
}
